<template>
  <!-- Marcadores de eventos propios -->
  <template>
    <l-marker
      v-for="evt in filteredOwnEvents"
      :key="evt.event_id"
      :title="evt.event_id"
      :lat-lng="[evt.location.coordinates[1], evt.location.coordinates[0]]"
      @click="selectMarker(evt.event_id)"
    >
      <l-icon :icon-size="iconSize" :icon-anchor="iconAnchor" class-name="point-event">
        <span class="point-head">{{ evt.event_unit + ' ' + evt.event_number }}</span>
        <div class="point-icon">
          <span>{{ evt.scope.substring(0, 1) }}</span>
          
          <img v-if="useUtils().getEventTypeId(evt.type) > 100" class="fondo-icono" :src="'/images/' +  useUtils().getEventBg(evt.type) + '.png'" alt="Fondo especial" />  
          <img
            class="icono"
            :src="'/images/event_type_' + getTypeId(evt.type) + '.png'"
            :alt="'Event type ' + evt.type"
          >
        
        </div>
      </l-icon>
      <l-tooltip>
        {{ evt.type }}<br>
        {{ evt.utc }}
      </l-tooltip>
    </l-marker>
  </template>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useServicesStore } from '@/stores/services';
import { storeToRefs } from 'pinia';
import { LMarker, LIcon, LTooltip } from "@vue-leaflet/vue-leaflet";
import { useUtils } from '@/composables/useUtils'

const serv = useServicesStore();
const { eventsPropios, eventTypes } = storeToRefs(serv);

const props = defineProps({
  isEvents: { type: Boolean, default: true }
});
const iconSize = ref<[number, number]>([35, 35]);
const iconAnchor = ref<[number, number]>([16, 37]);

const emit = defineEmits<{
  (event: 'eventSelected', seleccionado: any): void
}>();

const filteredOwnEvents = computed(() => {
  return eventsPropios.value.filter(evt => evt.user_visible == 1);
});

function selectMarker(eventId: number) {
  const selectedEvent = eventsPropios.value.find(({ event_id }) => event_id === eventId);
  if (selectedEvent) {
    emit('eventSelected', selectedEvent);
  }
}

function getTypeId(type: string) {
  let tipoEvento = eventTypes.value.find((tipo) => tipo.event_type === type);
  return tipoEvento ? tipoEvento.event_type_id : 5;
}
</script>

<style scoped>
.point-head {
  background-color: #d1b31ed9;
  display: block;
  font-size: 8px;
  text-align: center;
}
.point-icon {
  position: relative;
  border-radius: 10px 0;
  overflow: hidden;
  height: 25px;
}
.icono {
  width: 32px;
  height: 32px;
  z-index: 2;
  position: relative;
}
.fondo-icono {
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 32px;
    z-index: 1;
}
.icono-wrapper {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 32px;
}
</style>
